import htmx from "htmx.org";
import "idiomorph/htmx";

htmx.config.scrollIntoViewOnBoost = false;
